
<template>
    <div v-if="loaded">
        <iframe style="width:100%; height:800px; border:none;" allowtransparency="true" frameborder="0" scrolling="no" :src="this.$store.siteUrl + 'payments/do_redirect/' + payment_id"></iframe>

    </div> 
</template>

<script>
export default {
    props: ["order"],
    data(){
        return {
            loaded: false,
            payment_id: 0
        }
    },
    mounted(){
        
          this.net_api({action: 'pay', data: {id: this.order.id}}, (data) => {
              this.payment_id = data.data.payment_id;

              this.loaded = true;
        })

        // דף התוצאה של פלאקארד (בתוך ה-iframe) לא תמיד מצליח לנווט את החלון הראשי
        // (חסימת top.location מ-iframe חוצה דומיין) - מקבלים הודעה ומנווטים בעצמנו.
        window.addEventListener('message', this.onPaymentMessage);
    },
    beforeDestroy(){
        window.removeEventListener('message', this.onPaymentMessage);
    },
    methods: {
        onPaymentMessage(e){
            if (!e.data || e.data.type !== 'sukah_payment') return;
            if (e.data.status === 'success' && e.data.url) window.location.href = e.data.url;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>